/**
 * Consent state helpers — safe to call during SSR (returns false when window unavailable).
 * Reads from vanilla-cookieconsent's global API.
 */

const cc = () => (typeof window !== 'undefined' ? window.CookieConsent : null);

export const hasAnalyticsConsent = () => {
  try {
    return cc()?.acceptedCategory('analytics') ?? false;
  } catch {
    return false;
  }
};

export const hasMarketingConsent = () => {
  try {
    return cc()?.acceptedCategory('marketing') ?? false;
  } catch {
    return false;
  }
};

export const hasNecessaryConsent = () => {
  try {
    return cc()?.acceptedCategory('necessary') ?? false;
  } catch {
    return false;
  }
};
